import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const vendorList = createAsyncThunk('vendor/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `vendor`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'premise_id': data?.premise_id,
                'city_id': data?.city_id,
                'frequent': data?.frequent,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const vendorDetails = createAsyncThunk('vendor/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `vendor/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addVendor = createAsyncThunk('vendor/add', async (data) => {

    const bodyFormData = new FormData()

    bodyFormData.append('premise_id', data?.values?.premise_id ?? '')
    bodyFormData.append('vendor_name', data?.values?.company_name ?? '')
    bodyFormData.append('user_name', data?.values?.contact_person ?? '')
    bodyFormData.append('user_email', data?.values?.email ?? '')
    bodyFormData.append('user_mobile', data?.values?.mobile_number ?? '')
    bodyFormData.append('vendor_gst', data?.values?.gst_number ?? '')
    bodyFormData.append('city_id', data?.values?.city ?? '')
    bodyFormData.append('vendor_address', data?.values?.address ?? '')
    bodyFormData.append('status', data?.values?.status ?? 'Active')
    if (data?.values?.photo) {
        bodyFormData.append('user_profile', data.values.photo)
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'vendor',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", type: 'vendor_profile', Authorization: SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateVendor = createAsyncThunk('vendor/update', async (data) => {

    const bodyFormData = new FormData()

    bodyFormData.append('vendor_id', data?.values?.id)
    bodyFormData.append('premise_id', data?.values?.premise_id ?? '')
    bodyFormData.append('vendor_name', data?.values?.company_name ?? '')
    bodyFormData.append('user_name', data?.values?.contact_person ?? '')
    bodyFormData.append('user_email', data?.values?.email ?? '')
    bodyFormData.append('user_mobile', data?.values?.mobile_number ?? '')
    bodyFormData.append('vendor_gst', data?.values?.gst_number ?? '')
    bodyFormData.append('city_id', data?.values?.city ?? '')
    bodyFormData.append('vendor_address', data?.values?.address ?? '')
    bodyFormData.append('status', data?.values?.status ?? 'Active')
    if (data?.values?.photo) {
        bodyFormData.append('user_profile', data.values.photo)
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_vendor',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", type: 'vendor_profile', Authorization: SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delVendor = createAsyncThunk('vendor/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `vendor/${data?.id}`,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const vendor = createSlice({
    name: 'vendor',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(vendorList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(vendorList.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });
        builder.addCase(vendorList.rejected, (state) => {
            state.loading = false
        })

        builder.addCase(vendorDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default vendor.reducer;